module.exports = __webpack_public_path__ + "static/media/navbar-extra-shape-rafa.0da55a07.png";